/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import CustomSnackbar from "./CustomSnackBarMenu";
import API from "../../Utils/Interceptor/ApiMiddleware";
import { Grid } from "@mui/joy";
import PlusOneIcon from "@mui/icons-material/PlusOne";
import styled from "@emotion/styled";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function CandidateInternalProfile({ candidateId, data, jobId }) {
  const [openAttachmentDialog, SetopenAttachmentDialog] = useState(false);
  const [apiData, setApiData] = useState({});
  const [attachment, setAttachment] = useState(null);
  const [fileError, setFileError] = useState("");
  const [fileName, setFileName] = useState(null);
  const [uploadDate, setUploadDate] = useState(null);
  const [description, setDescription] = useState("");
  const [attachmentsType, setAttachmentsType] = useState("1");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [currentlocationID, setCurrentlocationID] = useState("");
  const [cityLoc, setCityLoc] = useState("");
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  // const [isDataChanged, setIsDataChanged] = useState(false);
  const [highEducationOptions, setHighEducationOptions] = useState([]);
  const [workAuthorizationOptions, setWorkAuthorizationOptions] = useState([]);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      placement="left-start"
      arrow
    />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      color: "#333",
      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
      fontSize: 14,
      whiteSpace: "normal",
    },
  }));

  const [details, setDetails] = useState({
    name: "",
    gender: "",
    dateOfBirth: "",
    email: "",
    phone: "",
    address: "",
    workAuthorization: "",
    customWorkAuthorization: "",
    highestEducation: "",
    noticePeriod: "",
    totalExperienceYears: "",
    totalExperienceMonths: "",
    currentEmployer: "",
    currentSalary: "",
    expectedSalary: "",
    linkedin: "",
    portfolio: "",
    currentLocation: "",
    dateModified: "",
    preferredLocation: [],
    attachments: [],
    miscellaneousNotes: "",
    lastWorkingDay: "",
    expectedJoiningDate: "",
    alternateEmail1: {
      contact: "",
      contact_id: null,
      contact_type: "email",
      is_primary: 0,
    },
    alternateEmail2: {
      contact: "",
      contact_id: null,
      contact_type: "email",
      is_primary: 0,
    },
    phonePrimary: {
      contact: "",
      contact_id: null,
      contact_type: "mobile",
      is_primary: 1,
    },
    alternatePhone1: {
      contact: "",
      contact_id: null,
      contact_type: "mobile",
      is_primary: 0,
    },
  });
  // const [customWorkAuthorization, setCustomWorkAuthorization] = useState("");
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const attachment_type = {
    1: "Resume",
    2: "Cover Letter",
    3: "Visa",
    4: "Passport",
    5: "Other",
  };

  useEffect(() => {
    if (apiData && Object.keys(apiData).length > 0) {
      const emailContacts =
        apiData.contacts?.filter((c) => c.contact_type === "email") || [];
      const mobileContacts =
        apiData.contacts?.filter((c) => c.contact_type === "mobile") || [];

      const primaryEmail = emailContacts.find((c) => c.is_primary === 1);
      const alternateEmails = emailContacts
        .filter((c) => c.is_primary === 0)
        .slice(0, 2);

      const primaryMobile = mobileContacts.find((c) => c.is_primary === 1);
      const alternateMobiles = mobileContacts
        .filter((c) => c.is_primary === 0)
        .slice(0, 2);
      const selectedOtherOrNot =
        apiData.work_authorization?.work_authorization === "Others";

      if (selectedOtherOrNot) {
        setIsOtherSelected(true);
      }

      // setCustomWorkAuthorization(apiData.work_authorization_text || "");
      setCityLoc(apiData.current_loc?.[0]?.label || "");
      setDetails((prev) => ({
        ...prev,
        name: apiData.name || "",
        gender: apiData.gender || "",
        dateOfBirth: apiData.dob || "",
        email: primaryEmail?.contact || "",
        phone: primaryMobile?.contact || "",
        address: apiData.address || "",
        workAuthorization:
          apiData.work_authorization?.work_authorization_id || "",
        customWorkAuthorization: apiData.work_authorization_text || "",
        highestEducation: apiData.highest_educ?.highest_education_id || "",
        noticePeriod: apiData.notice_period || "",
        totalExperienceYears: apiData.year || "",
        totalExperienceMonths: apiData.month || "",
        currentEmployer: apiData.current_employer || "",
        currentSalary: apiData.CTC || "",
        expectedSalary: apiData.Exp_CTC || "",
        linkedin: apiData.linkedIn || "",
        portfolio: apiData.portfolio || "",
        dateModified: apiData.date_modified || "",
        miscellaneousNotes: apiData.miscellaneous_notes || "",
        preferredLocation: apiData.preferred_loc || [],
        lastWorkingDay: apiData.last_working_day || "",
        expectedJoiningDate: apiData.expected_joining_date || "",
        attachments: apiData.attachments || [],
        alternateEmail1: {
          contact: alternateEmails[0]?.contact || "",
          contact_id: alternateEmails[0]?.contact_id || null,
          contact_type: "email",
          is_primary: 0,
        },
        alternateEmail2: {
          contact: alternateEmails[1]?.contact || "",
          contact_id: alternateEmails[1]?.contact_id || null,
          contact_type: "email",
          is_primary: 0,
        },
        phonePrimary: {
          contact: primaryMobile?.contact || "",
          contact_id: primaryMobile?.contact_id || null,
          contact_type: "mobile",
          is_primary: 1,
        },
        alternatePhone1: {
          contact: alternateMobiles[0]?.contact || "",
          contact_id: alternateMobiles[0]?.contact_id || null,
          contact_type: "mobile",
          is_primary: 0,
        },
      }));
    }
  }, [apiData]);
  const handleAttachmentDialog = () => {
    if (details.attachments.length >= 5) {
      setSnackbar({
        open: true,
        message: "You can upload maximum 5 attachments",
        severity: "error",
      });
    } else {
      SetopenAttachmentDialog(true);
      // setIsDataChanged(true);
    }
  };

  const getInternalProfile = async () => {
    try {
      const response = await API.get(
        `/job/internal-profile/${candidateId}${jobId ? `?jobId=${jobId}` : ""}`
      );
      if (response?.data?.success) {
        setApiData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching candidate data:", error.message);
    }
  };
  useEffect(() => {
    getInternalProfile();
    API.get(process.env.REACT_APP_JOBEZEURL + `/highest-education`)
      .then((res) => {
        setHighEducationOptions(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
    API.get(process.env.REACT_APP_JOBEZEURL + `/work-authorization`)
      .then((res) => {
        setWorkAuthorizationOptions(res.data.message);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    console.log("Uploaded file", file);
    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.text",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-powerpoint",
      "application/vnd.ms-excel",
      "application/msword",
      "application/rtf",
      "application/mspowerpoint",
      "application/powerpoint",
      "application/x-mspowerpoint",
      "application/vnd.oasis.opendocument.presentation",
    ];

    if (file && allowedTypes.includes(file.type)) {
      if (file.size <= 10485760) {
        setAttachment(file);
        setFileError("");
        setFileName(file.name);
        setUploadDate(new Date().toLocaleDateString());
      } else {
        setFileError("File size must be less than 10MB.");
        setAttachment(null);
      }
    } else {
      setFileError(
        "Only .ppt, .docx, .pdf, .txt, .xlsx, .xls, .png, .jpg, .jpeg, .doc, .rtf and .pptx,  files can be uploaded."
      );
      setAttachment(null);
    }
  };
  const handleClose = () => {
    SetopenAttachmentDialog(false);
    setAttachment(null);
    setFileError("");
    setAttachmentsType("1");
    setDescription("");
    setUploadProgress(0);
  };
  const handleCitySelect = (event, value, reason) => {
    if (value) {
      const selectedLocation = currentLocation.find(
        (loc) => loc.city === value
      );
      if (selectedLocation) {
        setSelectedCityId(selectedLocation.city_id);
      }
    } else {
      setSelectedCityId(null);
    }

    if (reason === "clear") {
      setCurrentlocationID(null);
      setSelectedCityId(null);
    }
  };

  const handleDescriptionChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length > 100) {
      setSnackbar({
        open: true,
        message: "Maximum 100 characters allowed",
        severity: "error",
      });
    } else {
      setDescription(newValue);
    }
  };
  const handleAttachmentTypeChange = (event) => {
    setAttachmentsType(event.target.value);
  };
  const handleDeleteAttachment = () => {
    setAttachment(null);
  };
  const handleSubmitAttachment = async () => {
    if (!attachment) {
      setSnackbar({
        open: true,
        message: "Please select a file to upload.",
        severity: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", attachment);
    formData.append("candidate_id", candidateId);
    formData.append("attachment_type", attachment_type[attachmentsType]);
    formData.append("description", description);

    try {
      const response = await API.post("/candidate/upload-attachment", formData);

      if (response.data?.success) {
        setSnackbar({
          open: true,
          message: response.data?.data || "Attachment uploaded successfully.",
          severity: "success",
        });
        handleClose();
        getInternalProfile();
      }
    } catch (error) {
      console.error("Error uploading attachment:", error);
      // handleClose();
      setSnackbar({
        open: true,
        message:
          error.response?.data?.message || "Failed to upload attachment.",
        severity: "error",
      });
    }
  };
  const deleteDialog = (attachment) => {
    setSelectedAttachment(attachment);
    setOpenDeleteDialog(true);
  };
  const closeDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedAttachment(null);
  };
  const handleDownload = (attachment) => {
    window.open(attachment, "_blank");
  };

  const fetchData = async () => {
    try {
      if (cityLoc && cityLoc.length > 0) {
        const response = await API.post(
          process.env.REACT_APP_JOBEZEURL + "/state-city/list",
          {
            cityName: cityLoc,
          }
        );
        response.data.message && response.data.message.length > 0
          ? setCurrentLocation(response.data.message)
          : setCurrentLocation(currentLocation);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  useEffect(() => {
    const ondata = async () => {
      await fetchData();
    };
    ondata();
  }, [cityLoc]);

  const handleDelete = async () => {
    try {
      const response = await API.delete(
        `candidate/attachment-remove/${selectedAttachment?.id}`
      );
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: response?.data?.data,
          severity: "success",
        });
        closeDeleteDialog();
        getInternalProfile();
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.success) {
        setSnackbar({
          open: true,
          message: error?.response?.data?.data,
          severity: "error",
        });
        closeDeleteDialog();
      }
    }
  };
  const scrollToErrorField = (fieldName) => {
    const errorFieldRef = errorFieldRefs[fieldName];
    if (errorFieldRef && errorFieldRef.current) {
      errorFieldRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };
  const errorFieldRefs = {
    name: useRef(null),
    phone: useRef(null),
    customWorkAuthorization: useRef(null),
    email: useRef(null),
    alternateEmail1: useRef(null),
    alternateEmail2: useRef(null),
    alternatePhone1: useRef(null),
    linkedin: useRef(null),
    miscellaneousNotes: useRef(null),
  };
  const handleSubmit = () => {
    console.log("Form Details", details);
    let newErrors = {};
    // setDrawerOpen(true);
    if (!details.name) newErrors.name = "Full Name is required.";
    if (details.alternateEmail1?.contact?.trim() !== "") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailRegex.test(details.alternateEmail1.contact)) {
        newErrors.alternateEmail1 = "Invalid email format.";
      } else if (details?.alternateEmail1?.contact.length > 165) {
        newErrors.alternateEmail1 =
          "Email length should not exceed 165 characters.";
      } else if (details.alternateEmail1.contact === details.email) {
        newErrors.alternateEmail1 =
          "Email cannot be the same as primary email.";
      }
    }
    if (details.alternateEmail2?.contact?.trim() !== "") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      if (!emailRegex.test(details.alternateEmail2.contact)) {
        newErrors.alternateEmail2 = "Invalid email format.";
      } else if (details?.alternateEmail2?.contact.length > 165) {
        newErrors.alternateEmail2 =
          "Email length should not exceed 165 characters.";
      } else if (
        details.alternateEmail2.contact === details.email ||
        details.alternateEmail2.contact === details.alternateEmail1.contact
      ) {
        newErrors.alternateEmail2 =
          "Email cannot be the same as primary email or alternate email.";
      }
    }

    if (details?.phonePrimary?.contact) {
      if (!/^\d{10}$/.test(details?.phonePrimary?.contact)) {
        newErrors.phone = "It should contain exactly 10 digits.";
      }
    }
    if (details.alternatePhone1?.contact) {
      if (!/^\d{10}$/.test(details.alternatePhone1.contact)) {
        newErrors.alternatePhone1 = "It should contain exactly 10 digits.";
      } else if (
        details.alternatePhone1.contact === details.phonePrimary.contact
      ) {
        newErrors.alternatePhone1 =
          "Mobile number cannot be the same as Primary mobile.";
      }
    }

    if (
      details.workAuthorization === 9 &&
      (!details.customWorkAuthorization ||
        details.customWorkAuthorization.trim() === "")
    ) {
      newErrors.customWorkAuthorization =
        "Other work authorization is required.";
    }

    if (details.linkedin !== "") {
      const pattern =
        /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)\/([-a-zA-Z0-9]+)\/*/gm;
      if (!pattern.test(details.linkedin)) {
        newErrors.linkedin = "Invalid LinkedIn URL.";
      }
    }
    if (details?.portfolio && details.portfolio.length > 128) {
      newErrors.portfolio =
        "Portfolio URL length should not exceed 128 characters.";
    }

    if (details?.miscellaneousNotes && details.miscellaneousNotes.length > 1000) {
      newErrors.miscellaneousNotes = "Maximum 1000 characters required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      scrollToErrorField(Object.keys(newErrors)[0]);
      return;
    }
    const payload = {
      fullname: details.name || "",
      gender: details.gender || "",
      dob: details.dateOfBirth || "",
      address: details.address || "",
      work_authorization: details.workAuthorization || null,
      work_authorization_text: details.customWorkAuthorization || null,
      highest_educ: details.highestEducation || null,
      notice_period: details.noticePeriod || null,
      year: details.totalExperienceYears || "0",
      month: details.totalExperienceMonths || "0",
      current_employer: details.currentEmployer || "",
      CTC: details.currentSalary || "",
      Exp_CTC: details.expectedSalary || "",
      linkedin: details.linkedin || null,
      portfolio: details.portfolio || null,
      original_date_modified: details.dateModified || "",
      current_loc: selectedCityId
        ? selectedCityId
        : currentlocationID
        ? currentlocationID
        : null,

      miscellaneous_notes: details.miscellaneousNotes || null,
      last_working_day: details.lastWorkingDay || null,
      expected_joining_date: details.expectedJoiningDate || null,

      contacts: [
        {
          contact: details.email,
          contact_id: details.phonePrimary.contact_id || null,
          contact_type: "email",
          is_primary: 1,
        },
        {
          ...details.alternateEmail1,
        },
        {
          ...details.alternateEmail2,
        },
        {
          ...details.alternatePhone1,
        },
        {
          ...details.phonePrimary,
        },
      ],
    };

    API.post(`candidate/profile-update/${candidateId}`, payload).then((res) => {
      if (res?.data?.success) {
        setSnackbar({
          open: true,
          message: res?.data?.data,
          severity: "success",
        });
        getInternalProfile();
      } else {
        setSnackbar({
          open: true,
          message: res?.data?.data || "Something went wrong",
          severity: "error",
        });
      }
    });
    setErrors({});
  };
  const handleworkAuthorization = (e) => {
    const selectedValue = e.target.value;

    setDetails((prev) => ({
      ...prev,
      workAuthorization: selectedValue,
    }));

    setIsOtherSelected(selectedValue === 9);
  };

  return (
    <Box>
      <Button variant="contained" onClick={handleAttachmentDialog}>
        UPLOAD ATTACHMENT
      </Button>
      <Dialog
        open={openAttachmentDialog}
        onClose={() => SetopenAttachmentDialog(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "16px",
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            padding: "16px 24px",
          }}
        >
          <DialogTitle sx={{ padding: "0px" }}>Attachment</DialogTitle>
          <IconButton
            onClick={handleClose}
            sx={{ color: "#101828 !important" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent dividers>
          {!attachment ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #ccc",
                padding: "20px",
                borderRadius: "8px",
              }}
            >
              <CloudUploadIcon sx={{ fontSize: 50, color: "#0F91D2" }} />
              <Typography variant="h6">
                Select a file here or drop it here
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  marginRight: "4px",
                  gap: "3px",
                }}
              >
                File size not more than
                <Typography variant="body2" color={"error"}>
                  {" "}
                  10MB*
                </Typography>
              </Typography>
              <Button
                variant="contained"
                component="label"
                sx={{ marginTop: "10px" }}
              >
                Select File
                <input type="file" hidden onChange={handleFileUpload} />
              </Button>

              {fileError && (
                <Typography py={2} color="error">
                  {fileError}
                </Typography>
              )}
              {attachment && (
                <div>
                  <Typography variant="body2">File Name: {fileName}</Typography>
                  <Typography variant="body2">
                    Upload Date: {uploadDate}
                  </Typography>
                </div>
              )}
            </Box>
          ) : (
            <Box>
              <Typography
                variant="body1"
                sx={{ marginTop: "5px", fontWeight: "bold" }}
              >
                Attachment File
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <InsertDriveFileOutlinedIcon sx={{ marginRight: "10px" }} />
                  <Typography
                    title={attachment.name}
                    sx={{
                      textTransform: "capitalize",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      maxWidth: "200px",
                    }}
                    variant="body1"
                  >
                    {attachment.name}
                  </Typography>
                </Box>
                <Button
                  onClick={handleDeleteAttachment}
                  color="error"
                  //   disabled={!isDataChanged}
                >
                  Delete
                </Button>
              </Box>

              <Box>
                {uploadProgress > 0 && (
                  <Box sx={{ marginTop: "20px" }}>
                    <LinearProgress
                      variant="determinate"
                      value={uploadProgress}
                    />
                    <Typography
                      variant="body2"
                      color="textSecondary"
                    >{`${uploadProgress}%`}</Typography>
                  </Box>
                )}
              </Box>
              <Divider sx={{ margin: "20px 0" }} />
              <Box
                sx={{
                  marginBottom: "20px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    paddingRight: "30px",
                  }}
                >
                  Document Type
                </Typography>
                <FormControl
                  variant="outlined"
                  size="small"
                  sx={{ flexGrow: 1 }}
                >
                  <Select
                    value={attachmentsType}
                    onChange={handleAttachmentTypeChange}
                  >
                    {Object.keys(attachment_type).map((key) => (
                      <MenuItem key={key} value={key}>
                        {attachment_type[key]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    marginRight: "20px",
                    fontWeight: "bold",
                    paddingRight: "40px",
                  }}
                >
                  Description
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Description"
                  value={description}
                  onChange={handleDescriptionChange}
                  sx={{ flexGrow: 1 }}
                />
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ gap: "10px", padding: "8px 24px" }}>
          <Button onClick={handleClose} color="error">
            Cancel
          </Button>
          {attachment && (
            <Button onClick={handleSubmitAttachment} color="primary">
              Attach
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {details?.attachments.length > 0 && (
        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          {details.attachments.map((attachment) => (
            <>
              <Box
                position="relative"
                borderRadius={2}
                backgroundColor="#3F95EA0F;"
                width=" 100%"
              >
                <Box
                  key={attachment.id}
                  display="flex"
                  alignItems="center"
                  p={1}
                >
                  <InsertDriveFileOutlinedIcon />
                  <Box
                    ml={2}
                    flexGrow={1}
                    display="flex"
                    alignItems="center"
                    position="relative"
                  >
                    {attachment.attachment_type &&
                      attachment.attachment_type !== "Other" && (
                        <Typography
                          sx={{
                            position: "absolute",
                            top: "-22px",
                            padding: "0.5px 3px 0.5px 3px",
                            backgroundColor: "white",
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#3F95EA",
                          }}
                        >
                          {attachment.attachment_type}
                        </Typography>
                      )}

                    <Box display="flex" alignItems="center">
                      <Typography
                        variant="body1"
                        title={attachment.original_filename}
                        sx={{
                          textTransform: "capitalize",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          width: "100%",
                          color: "#000000D9",
                        }}
                      >
                        {(() => {
                          let filename = attachment.original_filename;
                          let displayFilename = "";

                          if (filename) {
                            let parts = filename.split(".");
                            let extension = parts.pop();
                            let nameWithoutExtension = parts.join(".");
                            if (nameWithoutExtension.length > 16) {
                              displayFilename =
                                window.location.pathname.includes(
                                  `/Manage-Candidates/${candidateId}`
                                )
                                  ? nameWithoutExtension.substring(0, 16) +
                                    "..." +
                                    extension
                                  : filename.length > 25
                                  ? nameWithoutExtension.substring(0, 60) +
                                    "..." +
                                    extension
                                  : filename;
                            } else {
                              displayFilename = filename;
                            }
                          }

                          return <span>{displayFilename}</span>;
                        })()}
                      </Typography>
                    </Box>
                  </Box>
                  <Box mt={1}>
                    <LightTooltip
                      title={
                        <>
                          <Typography
                            sx={{ typography: "subtitle2", color: "#000000A6" }}
                          >
                            {attachment.description}
                          </Typography>
                          <Typography
                            display="flex"
                            gap={2}
                            sx={{ typography: "subtitle2", color: "#000000A6" }}
                          >
                            <Typography variant="body2" color="#00000040">
                              Date:{" "}
                              {new Date(
                                attachment.date_created
                              ).toLocaleDateString()}
                            </Typography>
                            <Typography variant="body2" color="#00000040">
                              By: {attachment.created_by}
                            </Typography>
                          </Typography>
                        </>
                      }
                    >
                      <InfoOutlinedIcon sx={{ ml: 1 }} />
                    </LightTooltip>
                  </Box>
                  <IconButton
                    onClick={() => handleDownload(attachment.stored_filename)}
                    color="primary"
                  >
                    <Typography variant="body2" color={"primary"}>
                      Download
                    </Typography>
                  </IconButton>
                  <IconButton
                    onClick={() => deleteDialog(attachment)}
                    color="error"
                    // disabled={!isDataChanged}
                    sx={{
                      color: "grey",
                      "&.Mui-disabled": {
                        color: "grey",
                      },
                    }}
                  >
                    <Typography variant="body2" color="error">
                      Delete
                    </Typography>
                  </IconButton>
                </Box>
              </Box>
            </>
          ))}
          <Dialog open={openDeleteDialog} onClose={closeDeleteDialog}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this attachment?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDeleteDialog} color="error">
                Cancel
              </Button>
              <Button onClick={handleDelete} color="error">
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
      <Box sx={{ mt: 3 }}>
        <Box sx={{ mb: 5 }}>
          <h4>Basic Details</h4>
          <Grid container spacing={2}>
            <Grid item xs={4} sx={{ mt: 1 }}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
              >
                Name
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="fullname"
                size="small"
                fullWidth
                label="Full Name"
                variant="outlined"
                value={details.name}
                onChange={(e) =>
                  setDetails({ ...details, name: e.target.value })
                }
                error={!!errors.name}
                helperText={errors.name}
                onFocus={(e) => setErrors({ ...errors, name: "" })}
                inputRef={errorFieldRefs.name}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Gender
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl size="small" fullWidth>
                <InputLabel size="small" id="demo-simple-select-label">
                  {" "}
                  Gender{" "}
                </InputLabel>
                <Select
                  value={details.gender}
                  size="small"
                  label="Gender"
                  onChange={(e) =>
                    setDetails({ ...details, gender: e.target.value })
                  }
                >
                  <MenuItem value="M">Male</MenuItem>
                  <MenuItem value="F">Female</MenuItem>
                  <MenuItem value="O">Prefer not to respond</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Date of Birth
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  maxDate={dayjs().subtract(18, "year")}
                  label="Date of Birth"
                  value={
                    details.dateOfBirth ? dayjs(details.dateOfBirth) : null
                  }
                  onChange={(e) =>
                    setDetails({
                      ...details,
                      dateOfBirth: dayjs(e).format("YYYY-MM-DD"),
                    })
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Email
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="email"
                size="small"
                type="email"
                fullWidth
                label="Email"
                disabled
                variant="outlined"
                value={details.email}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Alternate Email 1
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="alternateEmail1"
                size="small"
                type="email"
                fullWidth
                label="Alternate Email 1"
                variant="outlined"
                value={
                  details.alternateEmail1 ? details.alternateEmail1.contact : ""
                }
                inputRef={errorFieldRefs.alternateEmail1}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    alternateEmail1: {
                      ...details.alternateEmail1,
                      contact: e.target.value,
                    },
                  });
                }}
                error={!!errors.alternateEmail1}
                helperText={errors.alternateEmail1}
                onFocus={(e) => setErrors({ ...errors, alternateEmail1: "" })}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Alternate Email 2
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="alternateemail2"
                size="small"
                type="email"
                fullWidth
                label="Alternate Email 2"
                variant="outlined"
                value={
                  details.alternateEmail2 ? details.alternateEmail2.contact : ""
                }
                inputRef={errorFieldRefs.alternateEmail2}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    alternateEmail2: {
                      ...details.alternateEmail2,
                      contact: e.target.value,
                    },
                  });
                }}
                error={!!errors.alternateEmail2}
                helperText={errors.alternateEmail2}
                onFocus={(e) => setErrors({ ...errors, alternateEmail2: "" })}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Mobile
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="Mobile"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PlusOneIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                label="Mobile Number"
                variant="outlined"
                value={details.phonePrimary?.contact || ""}
                type="tel"
                placeholder="Enter mobile number"
                onChange={(e) => {
                  const input = e.target.value;
                  if (/^\d{0,10}$/.test(input)) {
                    setDetails((prevDetails) => ({
                      ...prevDetails,
                      phonePrimary: {
                        ...prevDetails.phonePrimary,
                        contact: input,
                      },
                    }));
                  }
                }}
                error={!!errors.phone}
                helperText={errors.phone}
                onFocus={(e) => setErrors({ ...errors, phone: "" })}
                inputRef={errorFieldRefs.phone}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Alternate Mobile
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="Mobile"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PlusOneIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                fullWidth
                label="Mobile Number"
                variant="outlined"
                value={
                  details.alternatePhone1 ? details.alternatePhone1.contact : ""
                }
                type="tel"
                placeholder="Enter Alternate mobile number"
                onChange={(e) => {
                  const input = e.target.value;
                  if (/^\d{0,10}$/.test(input)) {
                    setDetails((prevDetails) => ({
                      ...prevDetails,
                      alternatePhone1: {
                        ...prevDetails.alternatePhone1,
                        contact: input,
                      },
                    }));
                  }
                }}
                error={!!errors.alternatePhone1}
                helperText={errors.alternatePhone1}
                onFocus={(e) => setErrors({ ...errors, alternatePhone1: "" })}
                inputRef={errorFieldRefs.alternatePhone1}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography color="text.secondary" sx={{ mt: 1 }}>
                Current Address
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="currentAddress"
                label="Current Address"
                multiline
                size="small"
                fullWidth
                minRows={2}
                value={details.address || ""}
                onChange={(e) => {
                  setDetails({
                    ...details,
                    address: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Work Authorization
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl size="small" fullWidth>
                <InputLabel size="small"> Work Authorization </InputLabel>
                <Select
                  value={details.workAuthorization || ""}
                  size="small"
                  label="Highest Education"
                  onChange={handleworkAuthorization}
                >
                  {workAuthorizationOptions.map((options) => (
                    <MenuItem
                      className="fw-bold"
                      value={options.work_authorization_id}
                    >
                      {options.work_authorization}
                    </MenuItem>
                  ))}
                </Select>
                {(details.workAuthorization === 9 || isOtherSelected) && (
                  <TextField
                    id="otherWorkauthorization"
                    size="small"
                    fullWidth
                    label="Other Work Authorization"
                    value={details.customWorkAuthorization}
                    onChange={(e) => {
                      setDetails({
                        ...details,
                        customWorkAuthorization: e.target.value,
                      });
                    }}
                    margin="normal"
                    error={!!errors.customWorkAuthorization}
                    helperText={errors.customWorkAuthorization}
                    onFocus={(e) =>
                      setErrors({ ...errors, customWorkAuthorization: "" })
                    }
                    inputRef={errorFieldRefs.customWorkAuthorization}
                  />
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mb: 5 }}>
          <h4>Professional Details</h4>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Total Experience
              </Typography>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <TextField
                id="years"
                size="small"
                fullWidth
                value={details.totalExperienceYears}
                label="Years"
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value;
                  if (
                    value === "" ||
                    (/^\d{1,2}$/.test(value) && Number(value) <= 40)
                  ) {
                    setDetails({ ...details, totalExperienceYears: value });
                  }
                }}
              />
              <FormControl size="small" fullWidth>
                <InputLabel size="small" id="demo-simple-select-label">
                  {" "}
                  Months{" "}
                </InputLabel>
                <Select
                  value={details.totalExperienceMonths}
                  size="small"
                  label="Months"
                  onChange={(e) =>
                    setDetails({
                      ...details,
                      totalExperienceMonths: e.target.value,
                    })
                  }
                  disabled={details.totalExperienceYears === "40"}
                >
                  {months.map((item) => {
                    return <MenuItem value={item}>{item}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Current Employer
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="currentEmployer"
                size="small"
                fullWidth
                label="Current Employer"
                variant="outlined"
                value={details.currentEmployer}
                onChange={(e) => {
                  setDetails({ ...details, currentEmployer: e.target.value });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Current Salary
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth>
                <InputLabel>Current Salary</InputLabel>
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  label="Current Salary"
                  placeholder="Current Salary"
                  size="small"
                  value={details.currentSalary}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                      setDetails({ ...details, currentSalary: input });
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Expected Salary
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth>
                <InputLabel>Expected Salary</InputLabel>
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  label="Expected Salary"
                  placeholder="Expected Salary"
                  size="small"
                  value={details.expectedSalary}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                      setDetails({
                        ...details,
                        expectedSalary: input,
                      });
                    }
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Current Location
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Autocomplete
                fullWidth
                size="small"
                value={cityLoc}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue.length >= 2) {
                    setTimeout(() => {
                      setCityLoc(newInputValue);
                    }, 100);
                  } else {
                    setCityLoc("");
                    setCurrentLocation([]);
                  }
                }}
                onChange={(event, value, reason) =>
                  handleCitySelect(event, value, reason)
                }
                options={
                  (currentLocation && currentLocation.map((ele) => ele.city)) ||
                  []
                }
                renderInput={(params) => (
                  <TextField {...params} label="Current Location" />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 2 }}
              >
                Preferred Location
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Autocomplete
                multiple
                value={details.preferredLocation}
                disabled
                // onChange={handleLocationChange}
                // onInputChange={(event, newInputValue) => {
                //   hanldePreferredInputChange(newInputValue);
                // }}
                options={details.preferredLocation || []}
                renderTags={(value, getTagProps) =>
                  value?.map((option, index) => (
                    <Chip
                      variant="filled"
                      {...getTagProps({ index })}
                      label={option.label}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    placeholder={
                      details.preferredLocation?.length > 0
                        ? ""
                        : "Preferred Location"
                    }
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Notice Period
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                fullWidth
                label="Notice Period"
                value={details?.noticePeriod}
                onChange={(e) => {
                  const input = e.target.value;
                  if (/^\d{0,3}$/.test(input)) {
                    setDetails({ ...details, noticePeriod: input });
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">Days</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Last working Day
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Last Working Day"
                  value={
                    details.lastWorkingDay
                      ? dayjs(details.lastWorkingDay)
                      : null
                  }
                  onChange={(e) => {
                    setDetails({
                      ...details,
                      lastWorkingDay: dayjs(e).format("YYYY-MM-DD"),
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Expected Joining Date
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Expected Joining Date"
                  minDate={dayjs()}
                  value={
                    details.expectedJoiningDate
                      ? dayjs(details.expectedJoiningDate)
                      : null
                  }
                  onChange={(e) => {
                    setDetails({
                      ...details,
                      expectedJoiningDate: dayjs(e).format("YYYY-MM-DD"),
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mb: 5 }}>
          <h4>Other Details</h4>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Highest Education
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <FormControl size="small" fullWidth>
                <InputLabel size="small" id="demo-simple-select-label">
                  {" "}
                  Highest Education{" "}
                </InputLabel>
                <Select
                  value={
                    details.highestEducation === 0
                      ? ""
                      : details.highestEducation
                  }
                  size="small"
                  label="Highest Education"
                  onChange={(e) => {
                    setDetails({
                      ...details,
                      highestEducation: e.target.value,
                    });
                  }}
                >
                  {highEducationOptions.map((options) => (
                    <MenuItem
                      className="fw-bold"
                      value={options.highest_education_id}
                    >
                      {options.highest_education}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Linkedin
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="linkedin"
                size="small"
                fullWidth
                label="LinkedIn URL"
                variant="outlined"
                value={details.linkedin}
                onChange={(e) =>
                  setDetails({ ...details, linkedin: e.target.value })
                }
                error={errors.linkedin}
                helperText={errors.linkedin}
                onFocus={() => setErrors({ ...errors, linkedin: "" })}
                inputRef={errorFieldRefs.linkedin}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Portfolio Link
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="portfolio"
                size="small"
                fullWidth
                label="Portfolio URL"
                placeholder="Portfolio Link/Personal Website"
                variant="outlined"
                value={details.portfolio}
                onChange={(e) =>
                  setDetails({ ...details, portfolio: e.target.value })
                }
                error={errors.portfolio}
                helperText={errors.portfolio}
                onFocus={() => setErrors({ ...errors, portfolio: "" })}
              />
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                color="text.secondary"
                className="fw-500"
                sx={{ mt: 1 }}
              >
                Miscellaneous Notes
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                id="notes"
                size="small"
                fullWidth
                label="Miscellaneous Notes"
                placeholder="Miscellaneous Notes"
                variant="outlined"
                multiline
                minRows={2}
                value={details.miscellaneousNotes}
                onChange={(e) =>
                  setDetails({ ...details, miscellaneousNotes: e.target.value })
                }
                error={errors.miscellaneousNotes}
                helperText={errors.miscellaneousNotes}
                onFocus={() => setErrors({ ...errors, miscellaneousNotes: "" })}
              />
            </Grid>

            <Grid
              item
              xs={12}
              display={"flex"}
              justifyContent={"flex-end"}
              mt={2}
            >
              <Button
                variant="contained"
                onClick={handleSubmit}
                // disabled={!isDataChanged}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ open: false, message: "", severity: "" })}
      />
    </Box>
  );
}
